module.exports = __webpack_public_path__ + "img/ageas.c0e39504.png";